import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SearchOrganization from "../views/searchview/SearchOrganization";
import Redirect from "../views/Redirect";
import EmployeeSearch from "../views/searchview/EmployeeSearch";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useSelector } from "react-redux";
import EmployeeClaimLeave from "../views/claimleaveview/EmployeeClaimLeave";
import Preferences from "../views/preferences/Preferences";
import Login from "../Login";
import LandingPage from "../components/LandingPage";
import ViewSectionPage from "../views/reports/ViewSectionPage";
import ReportViewPage from "../views/reports/ReportViewPage";
import { EventProvider } from "../EventContext";
import ManageMyView from "../views/reports/ManageMyView";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { matchReportUrl } from "../utils/helpers";
import Dashboard from "../views/visualization/Dashboard";
import TrendsAndBenchmarking from "../views/visualization/TrendsAndBenchmarking";
import DisabilitySnapshot from "../views/visualization/DisabilitySnapshot";
import DetailedSnapshotReport from "../views/visualization/DetailedSnapshotReport";
import NotFoundPage from "../views/claimleaveview/NotFoundPage";
import ErrorPage from "../views/claimleaveview/ErrorPage";
import MainLayout from "../MainLayout";

function AppRoutes() {
    const { user } = useSelector((state) => state.auth);
    const { totalParentOrganizations } = useSelector(
        (state) => state.organizations
    );

    // to find previews page URL
    const useFindPath = () => {
        const location = useLocation();
        const [currentPath, setCurrentPath] = useState([]);
        useEffect(() => {
            setCurrentPath([...currentPath, window.location.pathname]);
        }, [location]);

        return currentPath;
    };

    const previousUrl = useFindPath();

    const url = window.location.pathname;
    const urlDisplay = matchReportUrl(url);

    const [showInformationBanner, setShowInformationBanner] = useState(true);

    const hideInformationBanner = () => {
        setShowInformationBanner(false);
    };

    const [isPreferenceSaved, setIsPreferenceSaved] = useState(false);
    const [showNotification, setShowNotification] = useState(false);

    const handleSavedPreference = () => {
        setShowNotification(true);
    };
    const handleClosePreference = () => {
        setShowNotification(false);
    };
    useEffect(() => {
        if (isPreferenceSaved) {
            setShowNotification(true);

            const timer = setTimeout(() => {
                setShowNotification(false);
            }, 5000);
            return () => {
                if (timer) clearTimeout(timer);
            };
        }
    }, [isPreferenceSaved]);

    return (
        <HelmetProvider>
            <div id="container_main">
                <EventProvider>
                    <Header
                        showInformationBanner={showInformationBanner}
                        hideInformationBanner={hideInformationBanner}
                        handleSavedPreference={handleSavedPreference}
                        showNotification={showNotification}
                        handleClosePreference={handleClosePreference}
                    />

                    <main>
                        <div
                            className={`container-content ${urlDisplay ? "mx-54p" : "container"}`}
                        >
                            <div
                                className="row"
                                id="main-row-content"
                                tabIndex={-1}
                            >
                                <div
                                    className="col-md-12"
                                    style={{ padding: 0 }}
                                >
                                    <Routes>
                                        <Route
                                            path="/"
                                            element={
                                                <>
                                                    <Helmet>
                                                        <title>Redirect</title>
                                                    </Helmet>
                                                    <Redirect
                                                        previousUrl={
                                                            previousUrl
                                                        }
                                                    />
                                                </>
                                            }
                                        />
                                        <Route
                                            path="/login"
                                            element={<Login />}
                                        />

                                        <Route
                                            path="/no-records"
                                            element={<NotFoundPage />}
                                        />

                                        <Route
                                            path="/error"
                                            element={<ErrorPage />}
                                        />

                                        <Route
                                            path="/organization/:orgId/employees/:id"
                                            element={
                                                <MainLayout>
                                                    <Helmet>
                                                        <title>
                                                            Claim & Leave
                                                        </title>
                                                    </Helmet>
                                                    <EmployeeClaimLeave
                                                        previousUrl={
                                                            previousUrl
                                                        }
                                                        showInformationBanner={
                                                            showInformationBanner
                                                        }
                                                    />
                                                </MainLayout>
                                            }
                                        />

                                        {user && (
                                            <>
                                                <Route
                                                    path="/home"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Unum
                                                                    Insights
                                                                </title>
                                                            </Helmet>
                                                            <LandingPage
                                                                previousUrl={
                                                                    previousUrl
                                                                }
                                                            />
                                                        </>
                                                    }
                                                />

                                                <Route
                                                    path="/organization/:id/employees/search"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Search
                                                                </title>
                                                            </Helmet>
                                                            <EmployeeSearch
                                                                previousUrl={
                                                                    previousUrl
                                                                }
                                                            />
                                                        </>
                                                    }
                                                />
                                                <Route
                                                    path="/reportingcapabilities"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Reports
                                                                </title>
                                                            </Helmet>
                                                            <ViewSectionPage
                                                                previousUrl={
                                                                    previousUrl
                                                                }
                                                            />
                                                        </>
                                                    }
                                                />
                                                <Route
                                                    path="/reportingcapabilities/:viewtype"
                                                    element={
                                                        <ReportViewPage
                                                            previousUrl={
                                                                previousUrl
                                                            }
                                                        />
                                                    }
                                                />
                                                <Route
                                                    path="/reportingcapabilities/:viewType/manageviews"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Manage
                                                                    Reports
                                                                </title>
                                                            </Helmet>
                                                            <ManageMyView />
                                                        </>
                                                    }
                                                />

                                                <Route
                                                    path="/reportingcapabilities/manageviews"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Manage my
                                                                    reports
                                                                </title>
                                                            </Helmet>
                                                            <ManageMyView />
                                                        </>
                                                    }
                                                />
                                                <Route
                                                    path="/preferences"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Preferences
                                                                </title>
                                                            </Helmet>
                                                            <Preferences
                                                                previousUrl={
                                                                    previousUrl
                                                                }
                                                                setIsPreferenceSaved={
                                                                    setIsPreferenceSaved
                                                                }
                                                            />
                                                        </>
                                                    }
                                                />
                                                <Route
                                                    path="/dashboard"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Dashboards
                                                                </title>
                                                            </Helmet>
                                                            <Dashboard
                                                                previousUrl={
                                                                    previousUrl
                                                                }
                                                            />
                                                        </>
                                                    }
                                                />
                                                <Route
                                                    path="/dashboard/trendsAndBenchmarking"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Dashboards
                                                                </title>
                                                            </Helmet>
                                                            <TrendsAndBenchmarking
                                                                previousUrl={
                                                                    previousUrl
                                                                }
                                                            />
                                                        </>
                                                    }
                                                />

                                                <Route
                                                    path="/dashboard/disability-snapshot"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Dashboards
                                                                </title>
                                                            </Helmet>
                                                            <DisabilitySnapshot
                                                                previousUrl={
                                                                    previousUrl
                                                                }
                                                            />
                                                        </>
                                                    }
                                                />

                                                <Route
                                                    path="/dashboard/detailed-report"
                                                    element={
                                                        <>
                                                            <Helmet>
                                                                <title>
                                                                    Detailed
                                                                    Reports
                                                                </title>
                                                            </Helmet>
                                                            <DetailedSnapshotReport
                                                                previousUrl={
                                                                    previousUrl
                                                                }
                                                            />
                                                        </>
                                                    }
                                                />

                                                {totalParentOrganizations >
                                                    1 && (
                                                    <Route
                                                        path="/search"
                                                        element={
                                                            <>
                                                                <Helmet>
                                                                    <title>
                                                                        Search
                                                                    </title>
                                                                </Helmet>
                                                                <SearchOrganization
                                                                    previousUrl={
                                                                        previousUrl
                                                                    }
                                                                />
                                                            </>
                                                        }
                                                    />
                                                )}
                                            </>
                                        )}

                                        <Route
                                            path="*"
                                            element={
                                                <Navigate replace to="/" />
                                            }
                                        />
                                    </Routes>
                                </div>
                            </div>
                        </div>
                    </main>

                    <Footer />
                </EventProvider>
            </div>
        </HelmetProvider>
    );
}

export default AppRoutes;
